import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { DESTINATIONS_SERVICE_KEY } from './destinationsEnum.js';

export default getGetterTypesForService(DESTINATIONS_SERVICE_KEY);
